<template>
    <div
        v-if="
            (content && content.length > 0) ||
            ((!content || content.length === 0) && emptyBehavior === 'mdash')
        "
        class="flex flex-wrap items-start gap-x-3"
    >
        <div
            class="shrink-0 font-proregular"
            :class="[
                `text-${size}`,
                {
                    'pt-0.5': size === 'sm',
                },
            ]"
        >
            {{ label || $t(ENUM_TRANSLATIONS[type]) }}:
        </div>
        <div
            v-if="content || emptyBehavior === 'mdash'"
            class="tags items-center"
        >
            <TagItem
                v-for="item in filteredContent"
                :key="
                    typeof item === 'string' || typeof item === 'number'
                        ? item
                        : item.ID
                "
                :item="item"
                :type
            />
            <button
                v-if="formattedContent.length > collapedLength"
                class="tag"
                :class="ENUM_CSS_CLASS[type]"
                @click="showAll = !showAll"
            >
                {{
                    showAll
                        ? $t("general.close").toLowerCase()
                        : $t("general.show_more")
                }}
                <i
                    class="pi text-xs"
                    :class="showAll ? 'pi-arrow-left' : 'pi-arrow-right'"
                />
            </button>
            <span
                v-if="
                    (!content || content.length === 0) &&
                    emptyBehavior === 'mdash'
                "
                >&mdash;</span
            >
        </div>
    </div>
</template>

<script lang="ts" setup>
import TagItem from "./TagItem.vue"

const MAX_COLLAPSED_LENGTH = 5
const showAll = ref(false)

const ENUM_CSS_CLASS = {
    klic_slova: "KEYWORDS",
    metriky: "METRIKY",
    dat_vrstvy: "DATOVE_VRSTVY",
    jevy: "JEVY",
    limity: "LIMITY",
    indikatory: "INDIKATORY",
    atlas: "ATLAS",
    "atlas-jevy": "ATLAS",
}

const {
    content,
    label,
    type,
    emptyBehavior = "hidden",
    size = "base",
    collapedLength = MAX_COLLAPSED_LENGTH,
} = defineProps<{
    content:
        | string
        | TemaKeywordItem[]
        | number[]
        | null
        | undefined
        | JevVrstvaItem[]
    label?: string
    type:
        | "klic_slova"
        | "metriky"
        | "dat_vrstvy"
        | "jevy"
        | "limity"
        | "indikatory"
        | "atlas"
        | "atlas-jevy"
    emptyBehavior?: "mdash" | "hidden"
    size?: "sm" | "base" | "lg"
    collapedLength?: number
}>()

const formattedContent = computed(() => {
    if (!content) return []
    if (typeof content === "string") {
        if (content.startsWith(",")) {
            return content.slice(1).split(",")
        }
        return content.split(",")
    }
    if (Array.isArray(content)) return content
    return [content]
})

const filteredContent = computed(() => {
    if (showAll.value) return formattedContent.value
    return formattedContent.value.slice(0, collapedLength)
})

const ENUM_TRANSLATIONS = {
    klic_slova: "general.klic_slova",
    metriky: "general.metriky",
    dat_vrstvy: "general.datove_vrstvy",
    jevy: "general.jevy",
    limity: "general.limity",
    indikatory: "general.indikatory",
    atlas: "search.results_atlas",
    "atlas-jevy": "search.results_atlas",
} as const
</script>

<style scoped></style>
